export default __webpack_public_path__ + "static/media/CardBackground1.8cec634b.png";